import { render, staticRenderFns } from "./vMenuStageFounders.vue?vue&type=template&id=6e94f6b7"
import script from "./vMenuStageFounders.vue?vue&type=script&lang=js"
export * from "./vMenuStageFounders.vue?vue&type=script&lang=js"
import style0 from "./vMenuStageFounders.vue?vue&type=style&index=0&id=6e94f6b7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports